import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

type DashboardProps = {};

const Dashboard = (props: DashboardProps) => {
  const { auth } = useContext(AuthContext);

  return auth.role === "ADMIN" ? (
    <Navigate to="/admin/dashboard" replace />
  ) : (
    <Navigate to="/user/dashboard" replace />
  );
};

export default Dashboard;
